<template>
  <div ref="menu" class="menu">
    <div class="header">
      <div class="header__left">
        <a href="/">
          <img src="@/assets/images/logo.svg" class="header__logo" />
        </a>
      </div>

      <div class="header__middle"></div>

      <div class="header__right">
        <IconButton
          form="transparent"
          :tag="mq.mdPlus ? 'button' : 'a'"
          class="header__icon"
          data-testid="search"
          icon="search"
          :href="mq.mdPlus ? '' : '/search'"
          @click="mq.mdPlus ? setSearchOpen(true) : null"
        />
        <IconButton
          form="transparent"
          :tag="isLoggedIn ? 'a' : 'button'"
          class="header__icon"
          icon="account"
          :href="isLoggedIn ? accountUrl : ''"
          @click="!isLoggedIn && setAccountOpen(true)"
        />
        <IconButton
          form="transparent"
          class="header__icon"
          icon="bag"
          :notification-number="lineItemsCount"
          @click="setCartOpen(true)"
        />
        <IconButton
          form="transparent"
          class="header__icon header__icon--no-padding-left"
          data-testid="burger-menu"
          icon="cross"
          @click="handleCrossClick()"
        />
      </div>
    </div>
    <div class="menu__content">
      <Navigation />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

import IconButton from "@/components/IconButton.vue";
import Navigation from "@/components/navigation/Navigation.vue";
import scrollLock from "@/helpers/scroll-lock";

export default {
  name: "BurgerMenu",
  components: {
    IconButton,
    Navigation,
  },
  inject: ["mq"],
  computed: {
    ...mapState("app", ["isLoggedIn"]),
    ...mapGetters("cart", ["lineItemsCount"]),
  },
  mounted() {
    scrollLock.enable();
  },
  unmounted() {
    scrollLock.disable();
  },
  methods: {
    ...mapActions("app", ["toggleMobileMenu", "closeMegaNav"]),
    ...mapActions("search", ["addSearchTerm", "setSearchOpen"]),
    handleCrossClick() {
      this.closeMegaNav();
      this.toggleMobileMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-color: $color-white;
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 8px 20px;

  &__middle {
    display: none;
  }

  &__left,
  &__right {
    flex: 1 0 auto;
  }

  &__left {
    display: flex;
    align-items: center;
  }

  &__right {
    display: flex;
    justify-content: flex-end;
    text-align: right;
  }

  &__icon {
    display: flex;
    align-items: center;
    font-size: 24px;
    line-height: 1;
    padding: 12px;

    &:last-child {
      margin-right: -7px;
    }
  }

  :deep(.button--icon--has-text .icon) {
    @include respond-below(xl) {
      margin-right: 0;
    }
  }

  &__logo {
    vertical-align: middle;
    width: 141px;
  }

  &__text {
    @include t__utility-label-20;
  }
}

.menu {
  position: absolute;
  background: $color-white;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;

  .header {
    flex: 0 0 auto;
  }

  &__content {
    flex: 0 1 100%;
    padding-top: 20px;
    overflow-x: scroll;
  }

  &__bottom {
    flex: 0 0 auto;
    background-color: $color-grey-light;
    border-top: 1px solid rgba($color-grey-dark, 0.2);
    display: flex;
    padding: 0 10px;
    justify-content: space-evenly;
  }

  &__button {
    padding: 17px 0;
    flex: 0 0 auto;
    background: none;
    outline: none;
    border: none;
    font-size: 10px;
    opacity: 0.4;
    text-decoration: none;

    &.router-link-active {
      opacity: 1;
    }
  }

  &__header {
    flex: 0 0 auto;
    background: $color-grey-light;
    padding-top: 16px;
    padding-bottom: 16px;

    .heading {
      font-size: 16px;
      text-transform: uppercase;
      font-family: $heading-font-family;
    }
  }
}

.parent-route {
  margin-top: 14px;
  background-color: $color-white;
}

.back-button {
  font-family: $body-font-family;
  font-size: 10px;
  display: block;
  width: 100%;
  text-decoration: none;
  padding: 14px 0;

  .icon-arrow-left {
    margin-right: 10px;
  }
}
</style>
